/**
 * CreateOrRotateLink -- "Create or rotate key" shortcut shown next to masked snippets and in the
 * ChatGPT gateway card (FEAT-056 TASK-007, design.md I). The host decides what it does: scroll to
 * the CTA of the API key tab, or navigate to /settings?tab=api-key.
 */

import { useIntl } from 'react-intl';
import { ArrowRight } from '@phosphor-icons/react';

export function CreateOrRotateLink({ onClick }: { onClick: () => void }) {
  const intl = useIntl();
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="create-or-rotate-link"
      className="group inline-flex items-center gap-1 text-xs text-text-accent underline-offset-2 hover:underline cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-focus"
    >
      {intl.formatMessage({ id: 'settings.apiKey.cta.createOrRotate' })}
      <ArrowRight size={14} aria-hidden="true" className="transition-transform group-hover:translate-x-0.5" />
    </button>
  );
}

export default CreateOrRotateLink;
